module.exports = __webpack_public_path__ + "static/media/CoverLetter_Wilson_Easton_Huffman.59d4cd80.pdf";